(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["decibel-inquiry-tracking"] && !Shopify.designMode) return;
  try {
    (() => {
    const PENDING_KEY = 'decibel:pending-project-inquiry:v1';
    const MAX_AGE = 30 * 60 * 1000;
    const TYPE_KEYS = ['architecture', 'retail', 'furniture', 'installations', 'production', 'other'];
    let context;
    let sending = false;

    function knownSource(value) {
      return value && Object.prototype.hasOwnProperty.call(context.sources, value) ? value : 'direct';
    }

    function sourceFromReferrer() {
      try {
        const referrer = new URL(document.referrer);
        if (referrer.origin !== window.location.origin) return 'direct';
        const view = referrer.searchParams.get('view');
        if (referrer.pathname.endsWith('/pages/custom-fabrication') && ['architectural-fabrication', 'retail-fabrication', 'why-lfam', 'selected-press', 'projects'].includes(view)) return view;
        return Object.keys(context.sources).find(key => context.sources[key] === referrer.pathname) || 'direct';
      } catch (_) { return 'direct'; }
    }

    function arrivalSource() {
      const source = knownSource(new URL(window.location.href).searchParams.get('project_source'));
      return source !== 'direct' ? source : sourceFromReferrer();
    }

    function liveStorefront() {
      return !context.designMode && window.Shopify?.theme?.role === 'main' && !window.Shopify?.designMode;
    }

    function analyticsAllowed() {
      try { return liveStorefront() && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
      catch (_) { return false; }
    }

    function clearPending() {
      try { window.sessionStorage.removeItem(PENDING_KEY); } catch (_) { /* Form delivery never depends on storage. */ }
    }

    function readPending() {
      try {
        const pending = JSON.parse(window.sessionStorage.getItem(PENDING_KEY));
        if (!pending || !/^db-[a-f0-9]{32}$/.test(pending.id) || !Number.isFinite(pending.at) || Date.now() - pending.at > MAX_AGE || pending.at > Date.now()) {
          clearPending();
          return null;
        }
        return pending;
      } catch (_) { return null; }
    }

    function makeId() {
      try {
        return 'db-' + Array.from(window.crypto.getRandomValues(new Uint8Array(16)), b => b.toString(16).padStart(2, '0')).join('');
      } catch (_) { return ''; }
    }

    function connectLinks() {
      const source = knownSource(context.source);
      if (source === 'direct' || !context.contactPath) return;
      document.querySelectorAll('a[href]').forEach(link => {
        try {
          const destination = new URL(link.getAttribute('href'), window.location.origin);
          if (destination.origin !== window.location.origin || destination.pathname.replace(/\/$/, '') !== context.contactPath.replace(/\/$/, '')) return;
          destination.searchParams.set('project_source', source);
          link.setAttribute('href', destination.pathname + destination.search + destination.hash);
        } catch (_) { /* Leave unusual links untouched. */ }
      });
    }

    function bindForm() {
      const form = document.querySelector('form.decibel-inquiry__form');
      if (!form || form.dataset.inquiryBound) return;
      form.dataset.inquiryBound = 'true';
      const sourceInput = form.querySelector('[data-inquiry-source]');
      const idInput = form.querySelector('[data-inquiry-id]');
      if (!sourceInput || !idInput) return;
      const source = arrivalSource();
      const id = makeId();
      sourceInput.value = context.sources[source];
      if (id) idInput.value = id;
      form.addEventListener('submit', () => {
        if (!form.checkValidity()) return;
        // Native Shopify submission, spam protection and delivery are unchanged.
        // Only a non-PII, short-lived success-correlation record is stored, with analytics permission.
        clearPending();
        if (!id || !analyticsAllowed()) return;
        const type = form.querySelector('[data-inquiry-type]')?.selectedOptions[0]?.dataset.typeKey;
        const pending = { id, source, type: TYPE_KEYS.includes(type) ? type : 'unspecified', at: Date.now() };
        try { window.sessionStorage.setItem(PENDING_KEY, JSON.stringify(pending)); } catch (_) { /* Send the form normally. */ }
      });
    }

    function publishSuccess() {
      if (sending || !document.querySelector('[data-decibel-inquiry-success]') || !analyticsAllowed()) return;
      const pending = readPending();
      if (!pending || typeof window.Shopify?.analytics?.publish !== 'function') return;
      const source = knownSource(pending.source);
      sending = true;
      try {
        window.Shopify.analytics.publish('decibel:project_inquiry_submitted', {
          inquiry_id: pending.id,
          source_key: source,
          source_page: context.sources[source],
          project_type: TYPE_KEYS.includes(pending.type) ? pending.type : 'unspecified',
          form_id: 'start_a_project',
          qualification_status: 'unreviewed'
        });
        clearPending();
      } catch (_) {
        sending = false;
      }
    }

    function init() {
      const element = document.getElementById('DecibelInquiryContext');
      if (!element) return;
      try { context = JSON.parse(element.textContent); } catch (_) { return; }
      connectLinks();
      bindForm();
      const status = document.querySelector('[data-decibel-inquiry-errors], [data-decibel-inquiry-success]');
      if (status) status.focus();
      if (document.querySelector('[data-decibel-inquiry-errors]')) clearPending();
      publishSuccess();
      if (liveStorefront() && !window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{name:'consent-tracking-api', version:'0.1'}], error => { if (!error) publishSuccess(); });
      }
    }

    document.addEventListener('visitorConsentCollected', () => {
      if (!context) return;
      if (!analyticsAllowed()) clearPending();
      else publishSuccess();
    });
    document.addEventListener('shopify:section:load', init);
    window.addEventListener('load', () => { if (context) publishSuccess(); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();
  } catch(e) { console.error(e); }
})();

})();
